import { useEffect, useState } from "react";
import { getBoard, type BoardColumn } from "../../lib/api";
import { KanbanBoardView } from "./KanbanBoardView";

/**
 * Secure /jobs page.
 *
 * Fetches the board column configuration from the backend (the single source of
 * truth) and renders the controlled Kanban board. Loading and error states are
 * handled before the board mounts.
 */
export function JobsPage() {
  const [columns, setColumns] = useState<BoardColumn[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    getBoard()
      .then((data) => {
        if (active) setColumns(data.columns);
      })
      .catch((e: unknown) => {
        if (active) setError(e instanceof Error ? e.message : "Failed to load board");
      });
    return () => {
      active = false;
    };
  }, []);

  if (error) {
    return (
      <div className="app-error" role="alert">
        {error}
      </div>
    );
  }

  if (!columns) {
    return <div className="app-loading">Loading board…</div>;
  }

  return <KanbanBoardView columns={columns} />;
}
